import {Component, Input, OnInit} from "@angular/core";
import {ChannelConfig} from "../../../../model/channels.model";

@Component({
  selector: "admin-channel-view-desc",
  templateUrl: "./description.component.html",
  styleUrls: ["./description.component.css"]
})
export class AdminChannelViewDescriptionComponent implements OnInit {

  @Input() config?: ChannelConfig;

  constructor() {
  }

  ngOnInit(): void {
    console.log("definition.config:", this.config);
  }
}
